import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import M from "materialize-css";

export default function Header(props) {
  useEffect(() => {
    var elems = document.querySelectorAll(".sidenav");
    var instances = M.Sidenav.init(elems, { edge: "left" });
  }, []);

  useEffect(() => {
    var elems = document.querySelectorAll(".materialboxed");
    var instances = M.Materialbox.init(elems, {
      inDuration: 500,
      outDuration: 500,
    });
  }, []);

  const linksModelos = () => {
    var links = props.modelos.map((modelo, i) => {
      return (
        <Link
          className="btn botonNavEstilo grey lighten-4 fontBold black-text waves-effect hoverable"
          key={i}
          to={"/" + modelo.modelo}
        >
          <b>{modelo.modelo}</b>
        </Link>
      );
    });
    return links;
  };

  const linksModelosMobile = () => {
    var links = props.modelos.map((modeloMobile, i) => {
      return (
        <ul key={i}>
          <li className="waves-effect" key={i}>
            <Link
              className="waves-effect sidenav-close"
              onClick={scrollTop}
              key={i}
              to={"/" + modeloMobile.modelo}
            >
              {modeloMobile.modelo}
            </Link>
          </li>
        </ul>
      );
    });
    return links;
  };

  const scrollTop = () => {
    window.scroll({
      top: 0,
    });
  };

  return (
    <div>
      <div className="hide-on-med-and-up">
        <ul id="slide-out" className="sidenav">
          <li>
            <div className="user-view">
              <div className="background">
                <img
                  className="fondoMobile"
                  src="images/fondos/fondoSide.jpg"
                  alt="background mobile"
                />
              </div>
              {/*<a href="https://www.toyota.com.ar/" title="Toyota Argentina" target="_blank">*/}
              <img
                className="toyotaLogoMobile"
                src="images/logos/toyotaLogo.png"
                alt="Toyota logo mobile"
              />
              {/*</a>*/}{" "}
            </div>
          </li>
          <li>
            <Link to="/" className="sidenav-close">
              ¿AUTOS EN STOCK?
            </Link>
          </li>
          <li>
            {" "}
            <a
              className="modal-trigger"
              data-target="modal-video"
              onClick={() => props.handleMostrarModal(true)}
            >
              ¿COMO COMPRAR?
            </a>
          </li>
          <li>
            <div className="divider"></div>
          </li>
          {linksModelosMobile()}
          <ul>
            <li>
              <Link
                className="waves-effect sidenav-close"
                onClick={scrollTop}
                to="/contacto"
              >
                CONTACTO
              </Link>
            </li>
          </ul>
        </ul>
        <div className="navbar-fixed">
          <nav className="black">
            <a data-target="slide-out" className="sidenav-trigger">
              <i className="material-icons white-text">menu</i>
            </a>
            <Link to="/">
              <img
                className="pranaLogoMobile"
                src="images/logos/pranaLogo.png"
              />
            </Link>
          </nav>
        </div>
      </div>

      <div className="contenedorHeaderPrincipal" id="video-button-container">
        <img
          className="responsive-img hide-on-med-and-down show-on-medium"
          src="images/fondos/main-top-3.png"
          alt="fondo desktop"
        />

        <a
          className="modal-trigger"
          data-target="modal-video"
          style={{ cursor: "pointer" }}
          onClick={() => props.handleMostrarModal(true)}
        >
          <img
            className="videoButtonHome"
            src="images/logos/video-button.png"
            alt="video button"
          />
        </a>

        {/*   <a
          href="https://www.toyota.com.ar/"
          title="Toyota Argentina"
          target="_blank"
          className="linkToyotaWebPrincipal"
        ></a> */}
        <Link to="/" className="linkPranaHomePrincipal"></Link>
      </div>

      <img
        className="responsive-img hide-on-med-and-up"
        src="images/fondos/main-top-m.png"
        alt="fondo mobile"
      />
      <h4 className="center fontBold">
        <b>Elegí tu próximo modelo, ¡0KM, cero vueltas!</b>
      </h4>
      <h6 className="center fontRegular">
        <b>
          Todos los modelos están disponibles, listos para ser patentados.
          ¡Reservá el tuyo ahora!
        </b>
      </h6>

      <nav className="center-align navBarEstilo">
        <Link
          className="btn botonNavEstilo grey lighten-4 fontBold black-text waves-effect hoverable"
          key={1}
          to={"/"}
        >
          <b>Home</b>
        </Link>
        {linksModelos()}
      </nav>
    </div>
  );
}
